/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Updated_RefreshingInputs */

const en_app_updated_refreshing = /** @type {(inputs: App_Updated_RefreshingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A new version is available. The page will refresh automatically.`)
};

const nl_app_updated_refreshing = /** @type {(inputs: App_Updated_RefreshingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een nieuwe versie is beschikbaar. De pagina wordt automatisch vernieuwd.`)
};

/**
* | output |
* | --- |
* | "A new version is available. The page will refresh automatically." |
*
* @param {App_Updated_RefreshingInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const app_updated_refreshing = /** @type {((inputs?: App_Updated_RefreshingInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Updated_RefreshingInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_app_updated_refreshing(inputs)
	return en_app_updated_refreshing(inputs)
});